import type { PhotoDetail } from '@/types/photo';
import { cookieRequest } from './api';

export type MemoryCategory = 'last_year' | 'past_today' | 'last_month' | 'photo_day';
export interface NotificationSettings {
  enabled: boolean;
  sendTime: string;
  lastYear: boolean;
  pastToday: boolean;
  lastMonth: boolean;
  photoDay: boolean;
  badgeEnabled: boolean;
  pushEnabled: boolean;
}
export interface MemoryNotification {
  id: number;
  category: MemoryCategory;
  title: string;
  body: string;
  imageUrl: string;
  targetUrl: string;
  memoryDate: string;
  photoCount: number;
  isRead: boolean;
  createdAt: string;
}

export const notificationService = {
  getSettings: () => cookieRequest<{ settings: NotificationSettings; vapidPublicKey: string }>('/api/notifications/settings'),
  saveSettings: (settings: NotificationSettings) => cookieRequest<{ settings: NotificationSettings }>('/api/notifications/settings', {
    method: 'PATCH', body: JSON.stringify(settings),
  }),
  list: () => cookieRequest<{ notifications: MemoryNotification[]; unreadCount: number }>('/api/notifications'),
  markRead: (id: number) => cookieRequest<{ ok: boolean; unreadCount: number }>(`/api/notifications/${id}/read`, { method: 'POST' }),
  markAllRead: () => cookieRequest<{ ok: boolean; unreadCount: number }>('/api/notifications/read-all', { method: 'POST' }),
  subscribe: (subscription: PushSubscriptionJSON) => cookieRequest<{ ok: boolean }>('/api/notifications/push-subscriptions', {
    method: 'POST', body: JSON.stringify(subscription),
  }),
  createPreview: () => cookieRequest<{ notification: MemoryNotification | null }>('/api/notifications/preview', { method: 'POST' }),
  getMemoryPhotos: (id: number) => cookieRequest<{ notification: MemoryNotification; photos: PhotoDetail[] }>(`/api/notifications/${id}/photos`),
};

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
